(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearComisionActaNewController", LebaniegoYearComisionActaNewController);

    LebaniegoYearComisionActaNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearComisionActa",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearComisionActaNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearComisionActa,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearComisionActa = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearComisionActa = Object.assign({}, vm.lebaniegoYearComisionActa);
            lebaniegoYearComisionActa.id = null;
            LebaniegoYearComisionActa.save(lebaniegoYearComisionActa, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-comission-proceeding", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el acta");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();